import { useEffect, type Dispatch, type SetStateAction } from 'react';
import { useLocation, useOutletContext } from 'react-router-dom';

export type PageTitle = { pathname: string; title: string } | null;
export type DashboardOutletContext = {
  setPageTitle: Dispatch<SetStateAction<PageTitle>>;
  headerActionsTarget: HTMLDivElement | null;
};

export function useHeaderActionsTarget() {
  return useOutletContext<DashboardOutletContext>().headerActionsTarget;
}

export function usePageTitle(title?: string | null) {
  const { pathname } = useLocation();
  const { setPageTitle } = useOutletContext<DashboardOutletContext>();
  useEffect(() => {
    if (!title) return;
    setPageTitle({ pathname, title });
    return () => setPageTitle(current => current?.pathname === pathname ? null : current);
  }, [pathname, title, setPageTitle]);
}
